var _style, _g, _g2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCriminal = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 55 55",
    style: {
      enableBackground: "new 0 0 55 55"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.7;}\n\t.st1{fill:#25D0F5;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 27.5,
    cy: 27.5,
    r: 26.3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.5,3.2c13.4,0,24.3,10.9,24.3,24.3S40.9,51.8,27.5,51.8S3.2,40.9,3.2,27.5S14.1,3.2,27.5,3.2 M27.5,1.2 C13,1.2,1.2,13,1.2,27.5S13,53.8,27.5,53.8S53.8,42,53.8,27.5S42,1.2,27.5,1.2L27.5,1.2z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M38.6,39.4V14.6c0-0.3-0.2-0.5-0.5-0.5c-0.3,0-0.5,0.2-0.5,0.5v22.6c-1.1-1.3-2.8-1.9-2.9-1.9 c-1.3-0.4-2.3-0.8-3-1.2c-0.3-0.2-0.5-0.3-0.7-0.5c-0.1-0.1-0.2-0.3-0.2-0.4v-1.5c0.8-0.7,1-1.5,1.1-2.2c0-0.1,0-0.2,0-0.3 c0.7-0.3,1-0.7,1.2-1.2c0.2-0.7-0.3-1.4-0.5-1.7c1.1-3.2,0.3-4.7-0.6-5.4v-6.2c0-0.3-0.2-0.5-0.5-0.5c-0.3,0-0.5,0.2-0.5,0.5v5.7 c-0.1,0-0.3-0.1-0.3-0.1c-0.4-0.4-1.5-1.2-3-1.2c-0.7,0-1.4,0.2-2.1,0.6c-0.1,0.1-0.2,0.1-0.3,0.2v-5.1c0-0.3-0.2-0.5-0.5-0.5 c-0.3,0-0.5,0.2-0.5,0.5v6.2c-0.9,1.1-1.3,2.4-1,3.8c0.1,0.5,0.2,1,0.4,1.6c-0.2,0.4-0.4,1.1-0.2,1.8c0.1,0.3,0.3,0.6,0.8,1 c0,0.6,0.2,1.9,1.1,2.6V33c0,0.2-0.1,0.3-0.2,0.4c-0.2,0.2-0.4,0.3-0.7,0.5c-0.8,0.4-1.8,0.9-3.1,1.2c-0.1,0.1-1.7,0.6-2.8,1.9V14.6 c0-0.3-0.2-0.5-0.5-0.5c-0.3,0-0.7,0.3-0.7,0.5v24.9c0,0.1,0,0.1,0,0.1v0.1c0,0.1,0.1,0.1,0.1,0.2c0,0,0,0,0,0.1 c0.1,0.1,0.1,0.1,0.2,0.1c0.2,0.1,0.3,0.1,0.3,0.1h20.3C38.4,40,38.7,39.7,38.6,39.4C38.7,39.4,38.6,39.4,38.6,39.4z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCriminal);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/criminal.43696ceadd79c7c60512504f94000040.svg";